import { render, staticRenderFns } from "./EditKYCExceptions.vue?vue&type=template&id=837c9ef0&"
import script from "./EditKYCExceptions.vue?vue&type=script&lang=js&"
export * from "./EditKYCExceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('837c9ef0')) {
      api.createRecord('837c9ef0', component.options)
    } else {
      api.reload('837c9ef0', component.options)
    }
    module.hot.accept("./EditKYCExceptions.vue?vue&type=template&id=837c9ef0&", function () {
      api.rerender('837c9ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/EditKYCExceptions.vue"
export default component.exports